import axios from '@/plugins/axios';
import { snackBarError } from '@/utils/snackbar';

export default {
	async fetchActivities({ commit }) {
		try {
			commit('setLoading', 'Cargando actividades...');
			const { data } = await axios(`/activities`, { method: 'get' });
			commit('setLoading', '');
			commit('setActivities', data);
			return true;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
};
